import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAppQuery } from "../api/baseQuery";
import { FactorInfo} from "shared/types/factor";

const ENDPOINT = "factor";
const factorsApi:any = createApi({
    reducerPath: "factorApi",
    baseQuery: baseAppQuery,
    refetchOnMountOrArgChange: true,
    tagTypes: ["factors"],
    endpoints:(builder)=>({
        getFactorList: builder.query<FactorInfo, FactorInfo>({
            query: ()=> `${ENDPOINT}/list`,
            providesTags: ["factors"]
        }),
    })
});

export const {
    useGetFactorListQuery
} = factorsApi;

export default factorsApi;